import React from 'react';

import {
  getOperativeSystem,
  OPERATIVE_SYSTEM_TYPES,
} from '../../products/constants';
import FEATURE_FLAGS, { useSafeFlag } from '../../utils/flags';
import {
  push,
  setupCFAndCCPLinks,
  setupCFLinks,
  togglePushInProgress,
} from '../actions';
import { connectEditor } from '../connect-editor';
import { campaignLineStatuses } from '../constants';
import { isDraft } from '../utils';
import CampaignPushButton from './CampaignPushButton';

export const CampaignPushButtonConnected = connectEditor(
  (
    { campaign, campaignLinesById, campaignUI: { pushInProgress } },
    {
      type,
      productCode,
      overCCPLimit,
      isZmsAmPushable,
      isDraftCampaignEnabled,
    },
  ) => {
    const { system, label: defaultLabel } = getOperativeSystem(
      isDraftCampaignEnabled,
    )[type];
    const label =
      system === OPERATIVE_SYSTEM_TYPES.zmsAm.system &&
      !productCode.includes('CCP')
        ? 'Push to Ad Manager as Draft'
        : defaultLabel;
    const { brandIds } = campaign;
    const campaignLinesRequiringSKUs = campaign.campaignLineIds
      .map(id => campaignLinesById[id])
      .filter(line => !isDraft(line))
      .filter(line => {
        const { product } = line;
        const { code } = product;
        if (productCode) {
          return code === productCode && product.checkSKUs;
        }
        return product.operativeSystem === system && product.checkSKUs;
      })
      .map(line => ({
        brandIds,
        categories: line.categories,
        gender: line.gender,
        country: line.country.code,
        name: line.name,
        startDate: line.startDate,
      }));

    const { READY } = campaignLineStatuses;
    const isAnyLineReady = Object.values(campaignLinesById).some(
      line => line.product.code === productCode && line.status === READY,
    );
    return {
      campaignLinesRequiringSKUs,
      label,
      pushInProgress,
      isDraftCampaignEnabled,
      isDisabled: isDraftCampaignEnabled
        ? !isAnyLineReady
        : overCCPLimit ||
          !isAnyLineReady ||
          (productCode.includes('CCP') && !isZmsAmPushable),
      isAnyLineReady,
    };
  },
  (dispatch, { type, productCode, productLabel, isDraftCampaignEnabled }) => {
    const { successMessage, errorMessage, system } = getOperativeSystem(
      isDraftCampaignEnabled,
    )[type];
    const setupLinks = isDraftCampaignEnabled
      ? setupCFLinks()
      : setupCFAndCCPLinks();

    return {
      onPush: () =>
        dispatch(
          push({
            system,
            successMessage: successMessage(productLabel),
            errorMessage: errorMessage(productLabel),
            productCode,
            isDraftCampaignEnabled,
          }),
        ).then(() => dispatch(setupLinks)),
      onPushProgressChange: status => dispatch(togglePushInProgress(status)),
    };
  },
  (stateProps, dispatchProps, { type, productLabel, ...rest }) => ({
    ...stateProps,
    ...dispatchProps,
    ...rest,
  }),
)(CampaignPushButton);

function CampaignPushButtonContainer(props) {
  const isDraftCampaignEnabled = useSafeFlag(FEATURE_FLAGS.DRAFT_CAMPAIGN);
  return (
    <CampaignPushButtonConnected
      {...props}
      isDraftCampaignEnabled={isDraftCampaignEnabled}
    />
  );
}

export default CampaignPushButtonContainer;
